import React from "react";
import { Link } from "react-router-dom";
const Ndashboard = () => {
  return (
    <>
      <section id="dash" className="n-dashboard">
        <div className="contain">
          <div className="dash_new_txt text-center">
            <h3>👋 Welcome back, John!</h3>
            <p>Let's find your dream job today.</p>
          </div>

          <div className="outer_cmn_blk_dash">
            <div className="cmn_blk_new_dash">
              <div className="top_head mb-3">
                <h4 className="heading_dash">My Jobs</h4>
                <div className="link_blk">
                  <Link to="">View all jobs</Link>
                </div>
              </div>
              <div className="flex">
                <div className="col">
                  <Link className="inner active" to="">
                    <div className="left_content">
                      <p>Saved</p>
                      <h5>12</h5>
                    </div>
                    <div className="right_content">
                      <div className="image_ico">
                        <img src="images/n-dashboard/job-1.svg" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link className="inner" to="">
                    <div className="left_content">
                      <p>Applied</p>
                      <h5>23</h5>
                    </div>
                    <div className="right_content">
                      <div className="image_ico">
                        <img src="images/n-dashboard/job-2.svg" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link className="inner" to="">
                    <div className="left_content">
                      <p>Interviewing</p>
                      <h5>7</h5>
                    </div>
                    <div className="right_content">
                      <div className="image_ico">
                        <img src="images/n-dashboard/job-3.svg" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link className="inner" to="">
                    <div className="left_content">
                      <p>Job Offers</p>
                      <h5>3</h5>
                    </div>
                    <div className="right_content">
                      <div className="image_ico">
                        <img src="images/n-dashboard/job-4.svg" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link className="inner" to="">
                    <div className="left_content">
                      <p>Rejections</p>
                      <h5>5</h5>
                    </div>
                    <div className="right_content">
                      <div className="image_ico">
                        <img src="images/n-dashboard/job-5.svg" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="middle_content">
                <div className="box_ico">
                  <img src="images/n-dashboard/job-6.svg" alt="" />
                </div>
                <div className="mobile_box_ico">
                  <img src="images/n-dashboard/job-7.svg" alt="" />
                </div>
                <div className="text_content">
                  <p>
                    <strong>No jobs applied yet</strong>
                  </p>
                  <p>
                    You haven't applied for any jobs. Start your job search
                    journey today!
                  </p>
                  <div className="cta">
                    <Link to="" className="site_btn">
                      Browse Open Positions
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ndashboard;
